//imports
import {
    DEVICE_DETAIL_GET_DATA_REQUEST,
    DEVICE_DETAIL_GET_DATA_REQUEST_RESULT,
    DEVICE_DETAIL_HIDE,
    DEVICE_DETAIL_SHOW,
    CLEAR_REDUX,
} from "Redux/actionTypes";

//initial values
const INIT_STATE = {
    loading: false,
    device: null,
    error: null,
    openModal: false,
    deviceId: null
};

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        
        case DEVICE_DETAIL_SHOW:
            return { ...state, openModal: true, deviceId: action.payload };

        case DEVICE_DETAIL_GET_DATA_REQUEST:
            return { ...state, loading: true };

        case DEVICE_DETAIL_GET_DATA_REQUEST_RESULT:
            return { ...state, loading: false, device: action.payload.data, error: action.payload.error };

        case DEVICE_DETAIL_HIDE:
            return { ...state, openModal: false };

        case CLEAR_REDUX:
            return ["", "DEVICE_DETAIL"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};
